export class SaleOrderBearingVisibility {
  constructor(
    public saleOrderBearingHash?: string,
    public saleOrderLineHash?: string
  ) { }

  clone() {
    return new SaleOrderBearingVisibility(
      this.saleOrderBearingHash,
      this.saleOrderLineHash
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/sale-order-bearing-visibility.ts